import React, { PureComponent, Fragment } from 'react';

// import ReactEcharts from "echarts-for-react";
import ReactEcharts from "echarts-for-react";





export default class BiaxialLineChart extends PureComponent {

  constructor(props) {
    super(props);

    var chartData = this.parseData(this.props.data) ;

    this.state = {
      yearList : chartData.yearList,
      newValueList : chartData.newValueList,
      renewValueList : chartData.renewValueList,
      renewRateValueList : chartData.renewRateValueList,
      totalValueList : chartData.totalValueList,
      totalTopValueList : chartData.totalTopValueList,
      totalBottomValueList : chartData.totalBottomValueList,
      sumValueList : Array.from(chartData.newValueList, () => 0),
      unselectedList : [],

      maxValue : chartData.maxValue
    }
  }

  componentWillReceiveProps = (nextProps) => {
      
    var chartData = this.parseData(nextProps.data) ;

    this.setState({
      yearList : chartData.yearList,
      newValueList : chartData.newValueList,
      renewValueList : chartData.renewValueList,
      renewRateValueList : chartData.renewRateValueList,
      totalValueList : chartData.totalValueList,
      totalTopValueList : chartData.totalTopValueList,
      totalBottomValueList : chartData.totalBottomValueList,
      sumValueList : Array.from(chartData.newValueList, () => 0),

      maxValue : chartData.maxValue
    });
  }


  containsList = (element) => {
    for (var i = 0; i < this.state.unselectedList.length; i++) {
      if (this.state.unselectedList[i] == element) {
        return i;
      }
    }
    return -1;
  }

  parseData = (chartData) => {

    var maxValue = 3000;

    var yearList = [];
    var newValueList = [];
    var renewValueList = [];
    var renewRateValueList = [];
    var totalValueList = [];

    var totalTopValueList = [];
    var totalBottomValueList = [];

    chartData.forEach(year => {
      yearList.push(year.name);
      newValueList.push(year["신규"]);
      renewValueList.push(year["재계약"]);
      renewRateValueList.push(year["재계약률"]);

      // totalValueList.push(year["신규"] + year["재계약"] + year["신규해지"] + year["재계약해지"]);
      

      var topVal = year["신규"] + year["재계약"] + year["신규해지"] + year["재계약해지"];
      if(Number(year.name) > 2018) topVal = topVal / 2;

      totalValueList.push(topVal);
      var bottomVal = year["신규"] + year["재계약"];

      if(bottomVal > topVal) {
        var tmp = topVal;
        topVal = bottomVal;
        bottomVal = tmp;
      } 
      topVal = topVal - bottomVal;
      totalTopValueList.push(topVal);
      totalBottomValueList.push(bottomVal);


      if(maxValue < (year["신규"] + year["재계약"] + year["신규해지"] + year["재계약해지"])) {
        maxValue = year["신규"] + year["재계약"] + year["신규해지"] + year["재계약해지"];
      }
    });

    maxValue = Math.ceil(maxValue/1000) * 1000;


    return {
      yearList : yearList,
      newValueList : newValueList,
      renewValueList : renewValueList,
      renewRateValueList : renewRateValueList,
      totalValueList : totalValueList,
      totalTopValueList : totalTopValueList,
      totalBottomValueList : totalBottomValueList,
      maxValue : maxValue
    }
  }

  onChartLegendSelectChanged (param, echart) {
    alert('onLegendSelect: ' + param +  echart);
  }

  _onEvent = {
    'click' : (params) => {
      this.props.yearChangeFn(params.name);
    },
    'legendselectchanged' : (params, chart) => {
      if (params.name == '신규' || params.name == '재계약') {
        var isSelected = params.selected[params.name];
        var index = this.containsList(params.name);
        if (isSelected)
        {
          if (index != -1) {
            this.state.unselectedList.splice(index, 1);
          }
        }
        else
        {
          if (index == -1) {
            this.state.unselectedList.push(params.name);
          }
        }

        chart.setOption({ animation: true });
      }
    }
  }

  _onAction = {
    type : 'highlight',
    name : this.props.year
  }

  onChartReadyCallback = (e) => {
    
    if(e) this.state.EchartInstance = e.getEchartsInstance();

    if(this.state.EchartInstance) {
      var dataIndex = 0;
      this.state.yearList.forEach((year, idx) => {
        if(this.props.year == year) dataIndex = idx;
      });

      // this.state.EchartInstance._api.dispatchAction({type : 'highlight',dataIndex : dataIndex})
    }
    
  }

  render() {

    const option = {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'cross',
                crossStyle: {
                    color: '#999'
                }
            },
            formatter : (params, chart, test) => {
                
                var tooltipHtml = "";

                params.map(e => {
                    if(!tooltipHtml) tooltipHtml += e.name + "<br/>";

                    if(e.seriesName !=="Sum") {
                        
                        tooltipHtml +=  e.marker.replace('none', '#FFFFFF')  + e.seriesName + " : "  + e.value.toLocaleString(); 
                        if(e.componentSubType === "line" && e.seriesName == '재계약률') tooltipHtml += " %";

                        tooltipHtml += " <br/>";
                    }

                });
                return tooltipHtml;
            }
        },
        legend: {
            data: ['신규', '재계약', '재계약률', '영업종료기준'],
            
        },
        xAxis: [
            {
                type: 'category',
                data: this.state.yearList,
                axisPointer: {
                    type: 'shadow'
                }
            }
        ],
        yAxis: [
            {
                type: 'value',
                name: '수량(건)',
                min: 0,
                max: this.state.maxValue,
                interval: this.state.maxValue / 5,
                axisLabel: {
                    formatter: (param) => { 
                        return param.toLocaleString();
                    }
                }
            },
            {
                type: 'value',
                name: '백분율(%)',
                min: 0,
                max: 100,
                interval: 20,
                axisLabel: {
                    formatter: '{value} %'
                }
            }
        ],
        series: [
            {
                name: '신규',
                type: 'bar',
                stack: 'one',
                itemStyle : {
                  borderColor : '#c23531',
                  borderWidth : 2,
                },
                data: this.state.newValueList,
                label : {
                    show : true,
                    position : "insideTop",
                    formatter: (param) => { 
                        return param.value.toLocaleString();
                    }
                },
            },
            {
                name: '재계약',
                type: 'bar',
                stack: 'one',
                itemStyle : {
                  borderColor : '#2f4554',
                  borderWidth : 2,
                },
                data: this.state.renewValueList,
                label : {
                    show : true,
                    position : "insideTop",
                    formatter: (param) => { 
                        return param.value.toLocaleString();
                    }
                }
            },
            {
                name: 'Sum',
                type: 'bar',
                stack: 'one',
                data: this.state.sumValueList,
                color: '#00fff',
                label : {
                    show : true,
                    position : "top",
                    formatter: (params) => {
                      let total = 0;
                      option.series.forEach(serie => {
                        if (serie.stack == 'one' && this.containsList(serie.name) == -1) {
                            total += serie.data[params.dataIndex];
                        }
                      })
                      return total.toLocaleString();
                    }
                }
            },
            {
                name: '재계약률',
                type: 'line',
                yAxisIndex: 1,
                data: this.state.renewRateValueList
            },
            {
                name: '영업종료기준',
                type: 'bar',
                barGap : '-100%',
                itemStyle : {
                  // opacity : 0  ,
                  color : 'none',
                  borderWidth : 2,
                  borderColor : 'auto',
                  borderType : "dashed"
                },
                z : 10,
                yAxisIndex: 0,
                label : {
                    show : false,
                    position : "top",
                    color : "#000000"
                },
                data: this.state.totalValueList
            },
            /*{
                name: '영업종료기준1',
                type: 'bar',
                barGap : '-100%',
                stack : 'two',
                itemStyle : {
                  // opacity : 0  ,
                  color : 'none',
                  borderWidth : 0
                },
                z : 12,
                data: this.state.totalBottomValueList
            },
            {
                name: '영업종료기준2',
                type: 'bar',
                barGap : '-100%',
                stack : 'two',
                itemStyle : {
                  color : 'none',
                  borderWidth : 1,
                  borderColor : (params) => {
                    let total = 0;
                    option.series.forEach(serie => {
                      if (serie.stack == 'one' && this.containsList(serie.name) == -1) {
                          total += serie.data[params.dataIndex];
                      }
                    })
                    console.log(total + " <= "+ params.data + " = " + total <= params.data);
                    if(total <= params.data) {
                      return "#000000"
                    } else {
                      return "#FFFFFF"
                    }
                    
                  },
                  borderType : "dashed"
                },
                // z : 12,
                data: this.state.totalTopValueList
            }*/
        ]
      }
    
    return (
      <ReactEcharts theme="macarons" ref={(e) => { this.onChartReadyCallback(e) }} option={option} onEvents={this._onEvent} onChartReady={this.onChartReadyCallback()} />
    );
  }
}
